<template>
  <v-card
    max-width="750"
    class="mx-auto"
    :loading="loading"
    :disabled="loading"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1>ค้นหา / แก้ไข ข้อมูลเริ่มต้น</h1>
      </v-toolbar-title>
    </v-toolbar>

    <v-form ref="form" @submit.prevent="">
      <v-row class="px-5 pt-5">
        <v-col cols="12" sm="4">
          <h4 class="pb-1">ค้นหาโดย</h4>
          <v-autocomplete
            density="compact"
            v-model="search_type_id"
            :items="search_type"
            :item-value="(item) => item.id"
            :item-title="(item) => item.name"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <h4 class="pb-1">คำค้นหา</h4>
          <v-text-field
            v-model="keyword"
            clearable
            class="pa-0"
            variant="solo-filled"
            density="compact"
            append-inner-icon="mdi-magnify"
          ></v-text-field
        ></v-col>
        <v-col cols="12" sm="4">
          <v-btn
            type="submit"
            color="primary"
            :loading="loading"
            :class="$vuetify.display.smAndUp ? 'mt-6' : 'mb-5'"
            variant="outlined"
            size="large"
            rounded="lg"
            @click="getUIDforInfo"
          >
            ค้นหา
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row v-if="multiple_uid.length > 1">
      <v-col>
        <h4 class="ml-5">พบหลายข้อมูล โปรดเลือก</h4>
        <v-list>
          <v-list-item
            v-for="(item, index) in multiple_uid"
            :key="index"
            :value="item"
            @click="select_uid(item.uid, item.status)"
            color="orange"
          >
            <template v-slot:prepend>
              <v-icon>mdi-account</v-icon>
            </template>
            <v-list-item-title class="ml-0">
              <span class="font-weight-bold text-primary">
                เลขที่ผู้สมัคร {{ item.apply_id }}
              </span>
              &nbsp;
              <span class="text-info">
                {{ item.level_id == "1" ? "ป.ตรี" : "บัณฑิตศึกษา" }}
                {{ item.student_id }} {{ item.status }}
              </span>
              &nbsp;
              {{ item.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-card
      max-width="700px"
      height="100%"
      class="mx-auto my-5"
      elevation="0"
      variant="outlined"
      v-if="uid"
    >
      <v-card-title class="text-h3"> ข้อมูล </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <span class="pb-1 font-weight-bold">UID :</span> {{ uid }}
          </v-col>
          <v-col>
            <span class="pb-1 font-weight-bold">เลขที่ผู้สมัคร :</span>
            {{ register_id }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="pb-1 font-weight-bold">ระดับ :</span>
            {{ level_id == "1" ? "ปริญญาตรี" : "บัณฑิตศึกษา" }}
          </v-col>
          <v-col>
            <span class="pb-1 font-weight-bold">รหัสนักศึกษา :</span>
            {{ student_id }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="pb-1 font-weight-bold">คณะ :</span>
            {{ faculty_th }}
          </v-col>
          <v-col>
            <span class="pb-1 font-weight-bold">สาขา :</span>
            {{ curriculum_th }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="pb-1 font-weight-bold">บัตรประชาชน / Passport :</span>
            <v-text-field
              v-model="citizen_id"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
          <v-col>
            <span class="pb-1 font-weight-bold">สถานะการศึกษา :</span>
            {{ status }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="pb-1 font-weight-bold">[ไทย] ชื่อ :</span>
            <v-text-field
              v-model="f_name_th"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
          <v-col>
            <span class="pb-1 font-weight-bold">[ไทย] นามสกุล :</span>
            <v-text-field
              v-model="l_name_th"
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="pb-1 font-weight-bold">[Eng] ชื่อ :</span>
            <v-text-field
              v-model="f_name_en"
              variant="outlined"
              density="compact"
              disabled
            ></v-text-field>
          </v-col>
          <v-col>
            <span class="pb-1 font-weight-bold">[Eng] นามสกุล :</span>
            <v-text-field
              v-model="l_name_en"
              variant="outlined"
              density="compact"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-center mt-2">
        <v-btn
          color="primary"
          :loading="loading"
          class="text-none px-5"
          variant="flat"
          size="x-large"
          rounded="lg"
          @click="save_default_data"
        >
          บันทึกการแก้ไขข้อมูล
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
import {
  inlineTranslator,
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import UserProvider from "@/services/user.provider";
import { listFilter, getById } from "@/helper/filter";
import GenericProvider from "@/services/generic.provider";

const userService = new UserProvider();
const genericService = new GenericProvider();

export default {
  name: "FindAndEditData",
  data: () => ({
    loading: false,
    search_type: [
      {
        id: "REGISTER_ID",
        name: "เลขที่ผู้สมัคร",
      },
      {
        id: "CITIZEN_ID",
        name: "บัตรประชาชน",
      },
      {
        id: "STUDENT_ID",
        name: "รหัสนักศึกษา",
      },
    ],
    uid: null,
    keyword: null,
    search_type_id: "REGISTER_ID",
    f_name_th: null,
    l_name_th: null,
    f_name_en: null,
    l_name_en: null,
    citizen_id: null,
    level_id: null,
    student_id: null,
    status: null,
    register_id: null,
    faculty_th: null,
    curriculum_th: null,

    multiple_uid: [],
    facultys: [],
  }),
  components: {},
  computed: {},

  methods: {
    dt,
    getById,
    listFilter,
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      const data1 = await genericService
        .getRegistrarFaculty()
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.facultys = data1;
    },

    select_uid(uid, status) {
      this.uid = uid;
      this.get_user_info({ status });
    },

    async getUIDforInfo() {
      this.loading = true;
      this.uid = null;
      this.multiple_uid = [];
      const response = await userService
        .getUIDforInfo(this.keyword, this.search_type_id)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response) {
        if (response.length > 1) {
          //พบมากกว่า 1
          for (var i = 0; i < response.length; i++) {
            this.multiple_uid.push({
              uid: response[i].UID,
              name:
                response[i].STUDENT_FNAME_TH +
                " " +
                response[i].STUDENT_LNAME_TH,
              level_id: response[i].LEVEL_ID,
              apply_id: response[i].APPLY_ID,
              student_id: response[i].STUDENT_ID,
              status: response[i].status,
            });
          }
        } else {
          this.uid = response[0].UID;
          this.get_user_info({ status: response[0].status });
        }
      }
      this.loading = false;
    },

    async get_user_info({ status }) {
      const response = await userService
        .getUserInfo(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response) {
        this.f_name_th = response.STUDENT_FNAME_TH;
        this.l_name_th = response.STUDENT_LNAME_TH;
        this.f_name_en = response.STUDENT_FNAME_EN;
        this.l_name_en = response.STUDENT_LNAME_EN;
        this.citizen_id = response.CITIZEN_ID;
        this.student_id = response.STUDENT_ID;
        this.level_id = response.LEVEL_ID;
        this.register_id = response.APPLY_ID;
        this.status = status;

        const refData = await getById(
          this.facultys,
          response.FACULTY_ID,
          "faculty_id"
        );
        this.faculty_th = refData.faculty_name_th;

        const data2 = await genericService
          .getRegistrarCurriculum(
            response.LEVEL_ID,
            response.FACULTY_ID,
            response.CURRICULUM_ID
          )
          .catch((error) => {
            this.$toast.error(JSON.stringify(error.response.data.message));
          });
        this.curriculum_th = data2[0].curriculum_name_th;
      }
    },

    async save_default_data() {
      this.loading = true;
      const response = await userService
        .saveDefaultData({
          uid: this.uid,
          CITIZEN_ID: this.citizen_id ?? null,
          STUDENT_FNAME_TH: this.f_name_th ?? null,
          STUDENT_LNAME_TH: this.l_name_th ?? null,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("toast.save_successfully"));
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
    },
  },

  created() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.inline-h2 {
  color: black;
}
.card-todo-list {
  /* background-color: #3b3939; */
  /* color: wheat; */
  max-width: 1250px;
}

.custom-text {
  color: #f8d7da;
}
</style>
